import { useFormik } from 'formik'
import React, { FC } from 'react'
import { addBank } from '../../../adapters/bank'
import Button from '../../../components/Button'
import CustomDialog from '../../../components/Dialog/CustomDialog'
import Input from '../../../components/Input'
import Select from '../../../components/Select'
import { useToastContext } from '../../../contexts/toastContext'
import { banks } from '../../../helpers/bank'

interface AddBankDialogProps {
	open: boolean
	onClose: (v: boolean) => void

	type: string
	refresh: () => void
}
const AddBankDialog: FC<AddBankDialogProps> = ({ open, onClose, type, refresh }) => {
	const { addToast } = useToastContext()
	const { values, isSubmitting, handleChange, handleSubmit } = useFormik({
		initialValues: {
			type: type,
			accountName: '',
			accountNumber: '',
			bankCode: 'SCB',
		},
		onSubmit: async (values) => {
			try {
				const res = await addBank(values)

				addToast({
					variant: 'success',
					message: res.message,
				})
				refresh()
				onClose(false)
			} catch ({ message }) {
				addToast({
					variant: 'error',
					message: message,
				})
			}
		},
	})

	return (
		<CustomDialog open={open} onClose={onClose}>
			<div className="w-full sm:w-1/4 bg-white rounded-md p-6 transform">
				<div className="text-center">
					<h3 className="text-lg text-gray-900">เพิ่มธนาคาร ({type.toUpperCase()})</h3>
				</div>
				<form className="space-y-3 mt-5" autoComplete="off" onSubmit={handleSubmit}>
					<Input
						type="text"
						label="ชื่อบัญชี"
						name="accountName"
						required
						onChange={handleChange}
					/>
					<Input
						type="text"
						label="เลขที่บัญชี"
						name="accountNumber"
						required
						onChange={handleChange}
					/>
					<Select
						name="bankCode"
						label="ธนาคาร"
						value={values.bankCode}
						required
						onChange={handleChange}
					>
						{banks.map((bank) => (
							<option key={bank.bankCode} value={bank.bankCode}>
								{bank.bankName}
							</option>
						))}
					</Select>
					<div className="grid grid-cols-2 gap-4">
						<Button type="submit" disabled={isSubmitting}>
							ยืนยัน
						</Button>
						<Button
							type="button"
							color="text-gray-900 border border-gray-200 hover:border-gray-300"
							onClick={() => onClose(false)}
						>
							ยกเลิก
						</Button>
					</div>
				</form>
			</div>
		</CustomDialog>
	)
}

export default AddBankDialog
